export default __webpack_public_path__ + "static/media/step.1341f905.png";